module.exports = __webpack_public_path__ + "static/img/bg-tr.f579bc14.png";